var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nw-button",class:{actived:_vm.ac},style:({transform:_vm.dir==1?'skewx(25deg)':'skewx(-25deg)'})},[_c('span',{style:({transform:_vm.dir==1?'skewx(-25deg)':'skewx(25deg)'})},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23917708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/svolt/project/components/nanwang/button.vue
// module id = null
// module chunks = 